import { t } from '../core/i18n.js';
import { settings } from '../core/storage.js';
import { profiles } from '../core/profiles.js';
import { escapeHtml } from '../core/utils.js';

/* Categorías bloqueadas del control parental: una ventana ancha con las categorías agrupadas por proveedor dado de alta
   (y, dentro de cada uno, por directo / películas / series), con buscador y «marcar todo» por proveedor. */

const KINDS = [['live', 'live_tv'], ['vod', 'movie'], ['series', 'tv']];
let seq = 0;

/** [{ id, name, items: [{ kind, cat, key }] }] — el proveedor principal primero, luego los añadidos en su orden. */
export function groupByProvider(catalog) {
    const groups = new Map();
    const primary = catalog.profile || null;
    const nameOf = (sourceId) => {
        if (!sourceId) return primary ? primary.name : '';
        const p = profiles.get(sourceId);
        return p ? p.name : sourceId;
    };
    KINDS.forEach(([kind]) => {
        (catalog.categories[kind] || []).forEach((cat) => {
            const gid = cat.source || '';
            if (!groups.has(gid)) groups.set(gid, { id: gid, name: nameOf(gid), items: [] });
            groups.get(gid).items.push({ kind, cat, key: kind + ':' + cat.id });
        });
    });
    return Array.from(groups.values()).sort((a, b) => (a.id === '' ? -1 : b.id === '' ? 1 : 0));
}

export function openParentalCategories({ catalog, onSaved = () => {} }) {
    const app = window.app;
    const id = 'pcat-' + (++seq) + '-' + Date.now().toString(36);
    const custom = Object.assign({}, settings.get('parental').categories);
    const groups = groupByProvider(catalog);
    const lockedNow = (it) => (custom[it.key] != null ? custom[it.key] : !!it.cat.adult);

    const section = (g) => {
        const byKind = KINDS.map(([kind, icon]) => {
            const rows = g.items.filter((it) => it.kind === kind);
            if (!rows.length) return '';
            return `<div class="pcat-kind"><span class="mi">${icon}</span>${escapeHtml(t('parental.kind.' + kind))}<small>${rows.length}</small></div>
                <div class="pcat-rows">${rows.map((it) => `<label class="pcat-row" data-name="${escapeHtml(String(it.cat.name).toLowerCase())}"><span class="pcat-name">${escapeHtml(it.cat.name)}</span><input type="checkbox" data-key="${escapeHtml(it.key)}" ${lockedNow(it) ? 'checked' : ''}/></label>`).join('')}</div>`;
        }).join('');
        return `<section class="pcat-group" data-group="${escapeHtml(g.id)}">
            <header class="pcat-head"><span class="mi">dns</span><b>${escapeHtml(g.name || t('settings.providerInUse'))}</b><small data-count></small>
                <button type="button" class="btn pcat-all" data-all="1">${t('parental.markAll')}</button><button type="button" class="btn pcat-all" data-all="0">${t('parental.unmarkAll')}</button></header>
            ${byKind}</section>`;
    };

    const popup = app.popup.create({
        content: `<div class="popup catpick-popup admin-popup parental-popup" id="${id}">
            <div class="page">
                <div class="navbar"><div class="navbar-bg"></div><div class="navbar-inner">
                    <div class="title">${t('settings.parentalCategories')}</div>
                    <div class="right"><a href="#" class="link popup-close btn-icon" aria-label="${t('common.close')}"><span class="mi">close</span></a></div>
                </div></div>
                <div class="page-content">
                    <div class="pcat-body">
                        <p class="pw-note">${t('parental.catsHelp')}</p>
                        <div class="catpick-search"><span class="mi">search</span><input type="search" data-pcat-search placeholder="${escapeHtml(t('parental.catSearch'))}" autocomplete="off" autocapitalize="off"/></div>
                        <div data-pcat-list>${groups.map(section).join('') || `<p class="pw-note">${t('common.noResults')}</p>`}</div>
                    </div>
                </div>
                <div class="pcat-foot"><button type="button" class="btn" data-cancel>${t('common.cancel')}</button><button type="button" class="btn btn-primary" data-save>${t('common.save')}</button></div>
            </div>
        </div>`,
        on: {
            open(p) {
                const el = p.el;
                const refresh = () => el.querySelectorAll('.pcat-group').forEach((g) => {
                    const boxes = g.querySelectorAll('input[data-key]');
                    g.querySelector('[data-count]').textContent = t('parental.catCount', { n: Array.from(boxes).filter((b) => b.checked).length, total: boxes.length });
                });
                refresh();
                el.addEventListener('change', refresh);
                el.addEventListener('click', (e) => {
                    const all = e.target.closest('[data-all]');
                    if (all) {
                        // Solo las categorías que se ven con el filtro actual
                        el.querySelectorAll('[data-group="' + all.closest('.pcat-group').getAttribute('data-group') + '"] .pcat-row').forEach((row) => { if (!row.hidden) row.querySelector('input').checked = all.getAttribute('data-all') === '1'; });
                        refresh();
                    }
                    if (e.target.closest('[data-cancel]')) popup.close();
                    if (e.target.closest('[data-save]')) {
                        el.querySelectorAll('input[data-key]').forEach((cb) => { custom[cb.getAttribute('data-key')] = cb.checked; });
                        settings.set('parental', Object.assign({}, settings.get('parental'), { categories: custom }));
                        catalog.emit('change');
                        popup.close();
                        onSaved();
                    }
                });
                el.querySelector('[data-pcat-search]').addEventListener('input', (e) => {
                    const q = e.target.value.trim().toLowerCase();
                    el.querySelectorAll('.pcat-row').forEach((row) => { row.hidden = !!q && row.getAttribute('data-name').indexOf(q) === -1; });
                    el.querySelectorAll('.pcat-kind').forEach((k) => { const rows = k.nextElementSibling; k.hidden = rows.hidden = !rows.querySelector('.pcat-row:not([hidden])'); });
                    el.querySelectorAll('.pcat-group').forEach((g) => { g.hidden = !g.querySelector('.pcat-row:not([hidden])'); });
                });
            },
            closed(p) {
                p.destroy();
                const el = document.getElementById(id);
                if (el && el.parentNode) el.parentNode.removeChild(el);
            }
        }
    });
    popup.open();
    return popup;
}
